/** Height threshold that determines icon size to be small or medium */
export const ICON_SIZE_THRESOLD = 24;
